import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import SmartPopups from "./components/SmartPopups";

import HomePage from "./pages/HomePage";
import ActionsPage from "./pages/ActionsPage";
import EastSupportPage from "./pages/EastSupportPage";
import SolidarityPage from "./pages/SolidarityPage";
import DonationsPage from "./pages/DonationsPage";
import DonationSuccessPage from "./pages/DonationSuccessPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import PollsPage from "./pages/PollsPage";
import AuthCallback from "./pages/AuthCallback";
import NewsListPage from "./pages/NewsListPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import MapPage from "./pages/MapPage";
import AdminLayout from "./pages/admin/AdminLayout";
import DashboardPanel from "./pages/admin/DashboardPanel";
import MembresPanel from "./pages/admin/MembresPanel";
import CoordinationsPanel from "./pages/admin/CoordinationsPanel";
import ActualitesPanel from "./pages/admin/ActualitesPanel";
import EvenementsPanel from "./pages/admin/EvenementsPanel";
import InvitationsPanel from "./pages/admin/InvitationsPanel";
import EquipeVitrinePanel from "./pages/admin/EquipeVitrinePanel";
import CotisationsPanel from "./pages/admin/CotisationsPanel";
import ElectionsPanel from "./pages/admin/ElectionsPanel";
import SondagesPanel from "./pages/admin/SondagesPanel";
import CommunicationPanel from "./pages/admin/CommunicationPanel";
import DocumentsPanel from "./pages/admin/DocumentsPanel";
import NotificationsPanel from "./pages/admin/NotificationsPanel";
import ComptabilitePanel from "./pages/admin/ComptabilitePanel";
import ActivitePanel from "./pages/admin/ActivitePanel";
import CMSVitrinePanel from "./pages/admin/CMSVitrinePanel";
import MediasPanel from "./pages/admin/MediasPanel";
import BoutiquePanel from "./pages/admin/BoutiquePanel";
import SanctionsPanel from "./pages/admin/SanctionsPanel";
import VotesPanel from "./pages/admin/VotesPanel";
import MessagerieAdminPanel from "./pages/admin/MessagerieAdminPanel";
import { OrganisationPage, TeamPage, EventsPage, MediaPage, ContactPage, GuidesPage } from "./pages/StaticPages";
import { AProposPage, VisionPage, AxesPage, StatutsPage, AdhesionPage } from "./pages/AboutPages";
import LivePage from "./pages/LivePage";
import LivePanel from "./pages/admin/LivePanel";
import InstallAppPrompt from "./components/InstallAppPrompt";

function AppShell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const hideChromeRoutes = ["/login", "/register"];
  const hideChrome = hideChromeRoutes.includes(location.pathname) || location.pathname.startsWith("/admin");
  const isHome = location.pathname === "/";

  return (
    <>
      {!hideChrome && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/a-propos" element={<AProposPage />} />
          <Route path="/vision" element={<VisionPage />} />
          <Route path="/axes" element={<AxesPage />} />
          <Route path="/statuts" element={<StatutsPage />} />
          <Route path="/adhesion" element={<AdhesionPage />} />
          <Route path="/organisation" element={<OrganisationPage />} />
          <Route path="/equipe" element={<TeamPage />} />
          <Route path="/evenements" element={<EventsPage />} />
          <Route path="/medias" element={<MediaPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/guides" element={<GuidesPage />} />
          <Route path="/actualites" element={<NewsListPage />} />
          <Route path="/actualites/:newsId" element={<NewsDetailPage />} />
          <Route path="/actions" element={<ActionsPage />} />
          <Route path="/carte" element={<MapPage />} />
          <Route path="/soutien-est" element={<EastSupportPage />} />
          <Route path="/solidarite" element={<SolidarityPage />} />
          <Route path="/sondages" element={<PollsPage />} />
          <Route path="/dons" element={<DonationsPage />} />
          <Route path="/live" element={<LivePage />} />
          <Route path="/dons/succes" element={<DonationSuccessPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<DashboardPanel />} />
            <Route path="membres" element={<MembresPanel />} />
            <Route path="coordinations" element={<CoordinationsPanel />} />
            <Route path="actualites" element={<ActualitesPanel />} />
            <Route path="evenements" element={<EvenementsPanel />} />
            <Route path="invitations" element={<InvitationsPanel />} />
            <Route path="equipe-vitrine" element={<EquipeVitrinePanel />} />
            <Route path="medias" element={<MediasPanel />} />
            <Route path="boutique" element={<BoutiquePanel />} />
            <Route path="sanctions" element={<SanctionsPanel />} />
            <Route path="cotisations" element={<CotisationsPanel />} />
            <Route path="votes" element={<VotesPanel />} />
            <Route path="elections" element={<ElectionsPanel />} />
            <Route path="sondages" element={<SondagesPanel />} />
            <Route path="messagerie" element={<MessagerieAdminPanel />} />
            <Route path="communication" element={<CommunicationPanel />} />
            <Route path="documents" element={<DocumentsPanel />} />
            <Route path="cms-vitrine" element={<CMSVitrinePanel />} />
            <Route path="notifications" element={<NotificationsPanel />} />
            <Route path="comptabilite" element={<ComptabilitePanel />} />
            <Route path="activite" element={<ActivitePanel />} />
            <Route path="live" element={<LivePanel />} />
          </Route>
        </Routes>
      </main>
      {!hideChrome && <Footer />}
      {!hideChrome && <ChatWidget />}
      {isHome && <SmartPopups />}
      {!hideChrome && <InstallAppPrompt />}
      <Toaster position="top-right" richColors closeButton />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
